export default __webpack_public_path__ + "static/media/IMG_7468 copie copy.3a17b3e0.jpg";